<ion-content>
  <ion-list lines="none">
    <ion-item button (click)="invoke('copy')">
      <ion-icon name="link-outline" slot="start"></ion-icon>
      <ion-label>Copy Link</ion-label>
    </ion-item>
    <ion-item button (click)="invoke('outlook')">
      <ion-icon name="mail-outline" slot="start"></ion-icon>
      <ion-label>Microsoft Outlook</ion-label>
    </ion-item>
    <ion-item button (click)="invoke('teams')">
      <ion-icon name="chatbubbles-outline" slot="start"></ion-icon>
      <ion-label>Microsoft Teams</ion-label>
    </ion-item>
    <ion-item button (click)="invoke('share')" *ngIf="canNativeShare">
      <ion-icon name="share-social-outline" slot="start"></ion-icon>
      <ion-label>More Apps</ion-label>
    </ion-item>
    <ion-item button (click)="invoke('text')">
      <ion-icon name="chatbubble-outline" slot="start"></ion-icon>
      <ion-label>Text Message</ion-label>
    </ion-item>
  </ion-list>
</ion-content>
